import { TooltipContent } from '@anm/components/Tooltip';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import styled from 'styled-components';

export const ButtonWrapper = styled(ButtonLoader)`
  padding: 0 10px;
  font-size: 16px;
  min-width: 210px;
  line-height: 20px;
  pointer-events: all;

  &:before {
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  ${TooltipContent} {
    top: 62px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    min-width: 300px;
  }
`;
